<template>
  <v-row
    v-if="total"
    no-gutters
    align="center"
  >
    <v-col
      v-if="hasActions"
    >
      <slot name="action" />
    </v-col>
    <v-col
      v-if="total && showCounts"
      class="pl-2 caption font-weight-light"
      :cols="hasActions ? 'auto' : undefined"
    >
      Showing
      <span class="font-weight-medium">
        {{ from }} - {{ to }}
      </span>
      of
      <span class="font-weight-medium">
        {{ total }}
      </span>
      results
    </v-col>
    <v-col cols="auto">
      <v-pagination
        v-if="lastPage > 1"
        v-model="pageDirty"
        :total-visible="totalVisible"
        :length="lastPage"
      />
    </v-col>
  </v-row>
</template>

<script>
  export default {
    name: 'Pagination',
    props: {
      from: {
        type: Number,
        default: 0
      },
      to: {
        type: Number,
        default: 0
      },
      total: {
        type: Number,
        default: 0
      },
      lastPage: {
        type: Number,
        default: 1
      },
      page: {
        type: Number,
        default: 1
      },
      showCounts: {
        type: Boolean,
        default: true
      },
      hasActions: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      pageDirty: {
        get: function () {
          return this.page
        },
        set: function (val) {
          this.$emit('update:page', val)
        }
      }
    },
    beforeCreate() {
      this.totalVisible = this.$vuetify.breakpoint.xsOnly ? 7 : 11
    }
  }
</script>
